import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkerBusinessOwner = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "workerBusinessOwner",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16612",
		"data-name": "Group 16612",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12445",
				"data-name": "Path 12445",
				d: "M15,15.19H9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12446",
				"data-name": "Path 12446",
				d: "M8.541,14.9a6,6,0,1,1,6.916,0,1.03,1.03,0,0,0-.457.835V18.5A2.5,2.5,0,0,1,12.5,21h-1A2.5,2.5,0,0,1,9,18.5V15.737A1.037,1.037,0,0,0,8.541,14.9Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12447",
				"data-name": "Path 12447",
				d: "M20,5l1.19-1.19",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12448",
				"data-name": "Path 12448",
				d: "M4,15,2.81,16.19",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12449",
				"data-name": "Path 12449",
				d: "M5,4,3.81,2.81",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12450",
				"data-name": "Path 12450",
				d: "M20,15l1.19,1.19",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12451",
				"data-name": "Path 12451",
				d: "M21,10h1.69",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12452",
				"data-name": "Path 12452",
				d: "M1.31,10H3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12453",
				"data-name": "Path 12453",
				d: "M9,18h5.87",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12454",
		"data-name": "Path 12454",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgWorkerBusinessOwner;
